// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-foot span {\n  color: var(--sea);\n  font-size: 0.885rem;\n}\n.login-foot a:hover {\n  color: var(--sea) !important;\n  text-decoration: underline !important;\n}\n", ""]);
// Exports
module.exports = exports;
